@use '@dixa/lib-shared-tokens/scss' as *;

.valueContainer {
  @include ellipsis;
  max-width: 100%;
  /* This ensures the ellipsis is moved to the left. */
  direction: rtl;
}

.value {
  direction: ltr;
  unicode-bidi: bidi-override;
}

.subdued {
  color: var(--dixa-color-neutral-600);
}

.tooltipWrapper {
  min-width: 0;
}
